// extracted by mini-css-extract-plugin
module.exports = {"root":"WaterfallLayout_root__3FKhU","sm":"WaterfallLayout_sm__VOqFH","md":"WaterfallLayout_md__2WGb5","lg":"WaterfallLayout_lg__3hWfe"};